import { FolderCopy, Settings, Timeline } from "@mui/icons-material";
import { Chip } from "@mui/material";
import React from "react";
import { PageContainer } from "../components/Common/PageContainer";
import { DashboardLayout } from "../components/DashboardLayout/DashboardLayout";
import { FeatureCards } from "../components/FeatureCards";

export const OrionHomePage: React.FC = () => {
  const features = [
    {
      title: "Consulter mes dossiers",
      path: "/orion/assets",
      icon: <FolderCopy sx={{ fontSize: 40 }} />,
    },
    {
      title: "Consulter mes configurations",
      path: "/orion/configs",
      icon: <Settings sx={{ fontSize: 40 }} />,
    },
    {
      title: "Consulter mes flux",
      path: "/orion/workflows",
      icon: <Timeline sx={{ fontSize: 40 }} />,
      children: (
        <Chip
          label="Coming Soon"
          color="secondary"
          size="small"
          sx={{ mt: 1 }}
        />
      ),
    },
  ];

  return (
    <DashboardLayout>
      <PageContainer maxWidth={false} breadcrumbs={[]}>
        <FeatureCards features={features} />
      </PageContainer>
    </DashboardLayout>
  );
};
